export default __webpack_public_path__ + "static/media/volvo.a0da5318.svg";